module.exports = __webpack_public_path__ + "static/img/PHOTO-KRIPSOL-A4-1.ed695e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/bg/PHOTO-KRIPSOL-A4-1.png
// module id = vyOB
// module chunks = 4